import { useRef } from 'react';
import { orgID, postIdempotent } from '@yingbaba/api';
import type { Artifact } from '@yingbaba/types';

// Retain the command key if the response is lost, so retrying does not create another version.
export function useArtifactCreate() {
  const attempt = useRef({ fingerprint: '', key: '' });
  return async (payload: Record<string, unknown>) => {
    const fingerprint = JSON.stringify([orgID(), payload]);
    if (attempt.current.fingerprint !== fingerprint)
      attempt.current = { fingerprint, key: crypto.randomUUID() };
    const value = await postIdempotent<Artifact>('/artifacts', payload, attempt.current.key);
    attempt.current = { fingerprint: '', key: '' };
    return value;
  };
}
